import Users from '@/views/users/views/Users.vue';
import UsersMfaAndLocation from '@/views/users/views/UsersMfaAndLocation.vue';
import Roles from '@/views/users/views/Roles.vue';
import RolesVersion2 from '@/views/users/views/RolesVersion2.vue';
import Permissions from '@/views/users/views/Permissions.vue';
import PermissionCategories from '@/views/users/views/PermissionCategories.vue';
import UserCompanyBranchAccess from '@/views/users/views/UserCompanyBranchAccess.vue';

export default [
  {
    path: '/user-management/users/',
    component: Users,
    //component: () => import('@/views/users/views/Users.vue'),
    meta: { 
      requiresPermission: 'users.view', 
      requiresSubscription: 'users.view',
      featureName: 'Users' 
    } 
  },
  {
    path: '/user-management/mfa_and_location_settings/',
    component: UsersMfaAndLocation,
    //component: () => import('@/views/users/views/UsersMfaAndLocation.vue'),
    meta: { 
      requiresPermission: 'mfa_and_location_settings.view', 
      requiresSubscription: 'mfa_and_location_settings.view',
      featureName: 'Users Mfa And Location' 
    } 
  },
  {
    path: '/user-management/roles/',
    component: Roles,
    //component: () => import('@/views/users/views/Roles.vue'),
    meta: { 
      requiresPermission: 'roles.view', 
      //requiresSubscription: 'roles.view',
      featureName: 'Roles' 
    }
    //meta: { requiresPermission: 'roles'}
  },
  {
    path: '/user-management/roles-v2/',
    component: RolesVersion2,
    //component: () => import('@/views/users/views/Roles.vue'),
    meta: { 
      requiresPermission: 'roles.view', 
      //requiresSubscription: 'roles.view',
      featureName: 'Roles Version2' 
    }
    //meta: { requiresPermission: 'roles-v2'}
  },
  {
    path: '/user-management/permissions/',
    component: Permissions,
    //component: () => import('@/views/users/views/Permissions.vue'),
    meta: { 
      requiresPermission: 'permissions.view', 
      //requiresSubscription: 'permissions.view',
      featureName: 'Permissions' 
    }
    //meta: { requiresPermission: 'permissions'}
  },
  {
    path: '/user-management/permission_categories/',
    component: PermissionCategories,
    //component: () => import('@/views/users/views/Permissions.vue'),
    meta: { 
      requiresPermission: 'permission_categories.view', 
      //requiresSubscription: 'permission_categories.view',
      featureName: 'Permission Categories' 
    }
    //meta: { requiresPermission: 'permission-categories'}
  },
  {
    path: '/user-management/user_company_branch_access/',
    component: UserCompanyBranchAccess,
    //component: () => import('@/views/users/views/Permissions.vue'),
    meta: { 
      requiresPermission: 'user_company_branch_access.view', 
      requiresSubscription: 'user_company_branch_access.view',
      featureName: 'User Company Branch Access' 
    }
  }
];